import EmailIconSVG from "../assets/icons/EmailIconSVG";
import WhatsappIcon from "../assets/icons/WhatsappIcon";
import SmsTemplateIcon from "../assets/icons/SmsTemplateIcon";

export const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  // Union Territories
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

export const infoTextMap = {
  otpSent: "A 6-digit OTP has been sent to your email to verify your account.",
  verified: "Set a password of at least 8 characters with letters and numbers.",
};

export const selectFieldsOptions = [
  "equals",
  "notequals",
  "contains",
  "notcontains",
  "startswith",
  "endswith",
  "lessthan",
  "greaterthan",
];

export const newFieldData = {
  name: "",
  mandatory: false,
  duplicacy_allowed: true,
  displayName: "",
  reVerification: false,
  reVerificationModule: "",
  fieldShow: true,
  isPrepopulate: false,
  prepopulateValue: "",
  revalidate: false,
  validateWith: "",
  type: "text",
  validation: "no",
  sameUser: false,
  adminFieldEdit: true,
  adminFieldShow: true,
  otpExpiry: {
    isExpiryEnabled: false,
    isDivergeEnabled: false,
    time: "",
    expiryTime: "",
    otpField: "",
  },
  values: [""],

  minDateType: "",
  minDateValue: "",
  maxDateType: "",
  maxDateValue: "",
  fileType: [],
  rejection: false,
  size: "",
};

export const selectDataTypeOptions = [
  "text",
  "number",
  "select",
  "multiSelect",
  "date",
  "file",
  "button",
  "submit",
  "hidden",
  "checkbox",
  "multiSelectCheckbox",
  "password",
  "email",
  "radioButton",
];

export const validationMap = {
  text: ["no", "pan", "aadhar", "ifsc", "passport", "noSpecialCharacter"],
  number: ["no", "mobile", "pincode", "otp", "percentage"],
  email: ["no", "email", "emailValidation"],
  file: ["no", "digitalsignature+manual"],
  checkbox: ["no"],
  select: ["no"],
  multiSelect: ["no"],
  multiSelectCheckbox: ["no"],
  password: ["no"],
  radioButton: ["no"],
  date: ["no"],
  hidden: ["no"],
  button: ["no", "googlesignin"],
  submit: ["no"],
};

export const selectDefaultOptions = [
  {
    key: 1,
    label: "Option 1",
  },
];

export const selectDateOptions = [
  "datepicker",
  "year",
  "month",
  "week",
  "days",
];

export const selectFileTypeOptions = [
  { value: "jpg", label: "JPG" },
  { value: "jpeg", label: "JPEG" },
  { value: "pdf", label: "PDF" },
  { value: "png", label: "PNG" },
];

export const defaultNotificationsValues = {
  emailCheckboxValue: false,
  whatsappCheckboxValue: false,
  smsCheckboxValue: false,
  emailInputValue: "",
  whatsappInputValue: "",
  smsInputValue: "",
  smsField: "",
  emailField: "",
  whatsappField: "",
  cc: "",
  bcc: "",
  smsIsDiverge: false,
  emailIsDiverge: false,
  whatsappIsDiverge: false,
};

export const editShowAdminDefaultData = {
  verify: false,
  pagePreview: false,
  divergeJourney: false,
  isRejection: false,
};

export const submitButtonDefaultData = {
  showButton: false,
  buttonName: "",
  logoutShowButton: false,
  logoutButtonName: "",
  backShowButton: false,
  backButtonName: "",
};

export const notificationsDefaultData = {
  emailCheckboxValue: false,
  emailField: "",
  emailInputValue: "",
  emailInputCc: "",
  emailInputBcc: "",
  emailIsDiverge: false,

  smsCheckboxValue: false,
  smsField: "",
  smsInputValue: "",
  smsIsDiverge: false,

  whatsappCheckboxValue: false,
  whatsappField: "",
  whatsappInputValue: "",
  whatsappIsDiverge: false,
};

export const newModuleData = {
  fields: [],
  termsConditions: [
    { id: 1, show: false, value: "", hyperlink: false, hyperlinkValue: "" },
  ],
  popupAfterSubmit: [
    {
      id: 1,
      show: false,
      fieldName: "",
      value: "",
    },
  ],

  notifications: {
    emailCheckboxValue: false,
    emailField: "",
    emailInputValue: "",
    emailInputCc: "",
    emailInputBcc: "",
    emailIsDiverge: false,

    smsCheckboxValue: false,
    smsField: "",
    smsInputValue: "",
    smsIsDiverge: false,

    whatsappCheckboxValue: false,
    whatsappField: "",
    whatsappInputValue: "",
    whatsappIsDiverge: false,
  },
  dropoff: {
    isActive: false,
    emailCheckboxValue: false,
    emailField: "",
    emailInputValue: "",
    emailInputCc: "",
    emailInputBcc: "",

    smsCheckboxValue: false,
    smsField: "",
    smsInputValue: "",

    whatsappCheckboxValue: false,
    whatsappField: "",
    whatsappInputValue: "",

    isActiveCustomCode: false,
    customCodeValue: {
      name: "",
      message: "",
      payload: "",
      thirdPartyApiType: "",
    },
    dropOffTime: 300,
    isRepeated: false,
    maximumTries: 1,
  },
  conditionalFlow: [
    {
      field: "",
      inputValue: "",
      operator: "",
      sectionId: 1,
      conditionName: "",
      then: [
        {
          action: "hide",
          id: 1,
          moduleAndField: "",
          selectedoption: "",
        },
      ],
    },
  ],

  selectedProcess: "user",
  editAdmin: true,
  showAdmin: true,

  thirdPartyApiDataList: [],
  submitButton: {
    showButton: false,
    buttonName: "",
    logoutShowButton: false,
    logoutButtonName: "",
    backShowButton: false,
    backButtonName: "",
  },
  warningMessages: [],
  verify: false,
  pagePreview: true,
  divergeJourney: false,
  isRejection: false,
};

export const settingsMenu = {
  Templates: [
    {
      id: 1,
      path: "email-templates",
      title: "Email Templates",
      icon: <EmailIconSVG sx={{ marginRight: "0.5rem" }} />,
    },
    {
      id: 3,
      path: "sms-templates",
      title: "SMS Templates",
      icon: <SmsTemplateIcon sx={{ marginRight: "0.5rem" }} />,
    },
    {
      id: 2,
      path: "whatsapp-templates",
      title: "Whatsapp Templates",
      icon: <WhatsappIcon sx={{ marginRight: "0.5rem" }} />,
    },
  ],
};
